var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.path}),_c('notifications',{attrs:{"group":"main","position":"bottom right"}}),_c('modals-container'),_c('v-dialog'),_c('TekaChat',{attrs:{"isVisible":!['/', '/ResultAna'].includes(_vm.$route.path)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }